// Rich mock data for the Immigration "Know about Country" modal.
// Each country has: code, flag, name, tag, description, universities[{name, logo}].
// Facilities are shared across all countries (rendered from a constant in the modal).
// NOTE: "Other Countries" tile is rendered separately in ImmigrationDashboard.jsx
//       and is NOT part of this list.

const logo = (label, bg = "D90429") =>
  `https://placehold.co/80x80/${bg}/ffffff/png?text=${encodeURIComponent(label)}&font=montserrat`;

export const FACILITIES = [
  "University Fee & Admission Payment Transfer",
  "Accommodation Services",
  "Forex Services",
  "Forex Card Services",
  "Money Exchange",
  "SIM Card & Connectivity",
  "Study Loan Assistance",
];

const RAW_COUNTRIES = [
  {
    code: "CA",
    flag: "🇨🇦",
    name: "Canada",
    tag: "PGWP + PR pathway · 3-year post-study work permit",
    description:
      "Canada blends world-class universities with one of the friendliest immigration frameworks on the planet. Indian students get a 3-year Post-Graduation Work Permit, a clear PR pathway via Express Entry, universal healthcare in most provinces, and a thriving Indian community across Toronto, Vancouver and Montreal.",
    universities: [
      { name: "University of Toronto",            logo: logo("U of T") },
      { name: "McGill University",                logo: logo("McGill") },
      { name: "University of British Columbia",   logo: logo("UBC") },
      { name: "University of Waterloo",           logo: logo("UW") },
      { name: "University of Alberta",            logo: logo("UAlb") },
      { name: "McMaster University",              logo: logo("Mac") },
      { name: "Western University",               logo: logo("West") },
      { name: "University of Calgary",            logo: logo("UCal") },
      { name: "Queen's University",               logo: logo("Q's") },
      { name: "University of Ottawa",             logo: logo("UOtt") },
    ],
  },
  {
    code: "AU",
    flag: "🇦🇺",
    name: "Australia",
    tag: "Group of 8 universities · 485 post-study visa",
    description:
      "Study in the sunshine at one of the Group of 8 world-ranked universities. Australia offers a 2-4 year post-study work visa (subclass 485), a healthy minimum wage for part-time student jobs, and a straightforward pathway to Permanent Residency through the skilled migration list.",
    universities: [
      { name: "University of Melbourne",              logo: logo("UniM", "FFC300") },
      { name: "Australian National University",       logo: logo("ANU",  "FFC300") },
      { name: "University of Sydney",                 logo: logo("USyd", "FFC300") },
      { name: "UNSW Sydney",                          logo: logo("UNSW", "FFC300") },
      { name: "Monash University",                    logo: logo("Mon",  "FFC300") },
      { name: "University of Queensland",             logo: logo("UQ",   "FFC300") },
      { name: "University of Western Australia",      logo: logo("UWA",  "FFC300") },
      { name: "University of Adelaide",               logo: logo("UAdl", "FFC300") },
      { name: "Macquarie University",                 logo: logo("MQ",   "FFC300") },
      { name: "University of Technology Sydney",      logo: logo("UTS",  "FFC300") },
    ],
  },
  {
    code: "UK",
    flag: "🇬🇧",
    name: "United Kingdom",
    tag: "2-year Graduate Route visa · Global recognition",
    description:
      "The UK reinstated its 2-year Graduate Route visa in 2021 (3 years for PhDs), letting you work anywhere without sponsorship after graduation. Indian students are eligible for Chevening + Commonwealth scholarships, and UK degrees are recognised in 190+ countries.",
    universities: [
      { name: "University of Oxford",                     logo: logo("Ox",   "14213D") },
      { name: "University of Cambridge",                  logo: logo("Cam",  "14213D") },
      { name: "Imperial College London",                  logo: logo("IC",   "14213D") },
      { name: "University College London",                logo: logo("UCL",  "14213D") },
      { name: "London School of Economics",               logo: logo("LSE",  "14213D") },
      { name: "University of Edinburgh",                  logo: logo("Edin", "14213D") },
      { name: "King's College London",                    logo: logo("KCL",  "14213D") },
      { name: "University of Manchester",                 logo: logo("Man",  "14213D") },
      { name: "University of Bristol",                    logo: logo("Bris", "14213D") },
      { name: "University of Warwick",                    logo: logo("Warw", "14213D") },
    ],
  },
  {
    code: "US",
    flag: "🇺🇸",
    name: "United States",
    tag: "F1 visa · Up to 3-year STEM OPT",
    description:
      "The US remains the world's largest hub for higher education, with 4,000+ accredited institutions and up to 3 years of Optional Practical Training (OPT) for STEM graduates. Ivy League + top public universities dominate global rankings, and Indian graduates enjoy the strongest STEM job market on earth.",
    universities: [
      { name: "Massachusetts Institute of Technology",   logo: logo("MIT") },
      { name: "Stanford University",                     logo: logo("Stan") },
      { name: "Harvard University",                      logo: logo("Harv") },
      { name: "California Institute of Technology",      logo: logo("CalT") },
      { name: "University of Chicago",                   logo: logo("UChi") },
      { name: "Princeton University",                    logo: logo("Prin") },
      { name: "Yale University",                         logo: logo("Yale") },
      { name: "Columbia University",                     logo: logo("Col") },
      { name: "University of Pennsylvania",              logo: logo("Penn") },
      { name: "Cornell University",                      logo: logo("Cor") },
    ],
  },
  {
    code: "DE",
    flag: "🇩🇪",
    name: "Germany",
    tag: "Public universities · Almost free tuition",
    description:
      "Germany's public universities charge little to no tuition even for international students. Engineering, automotive R&D and quantum computing are world-class here. You get an 18-month post-study job-seeker visa and a clear EU Blue Card pathway to PR in 21 months.",
    universities: [
      { name: "Technical University of Munich",          logo: logo("TUM",  "14213D") },
      { name: "Ludwig Maximilian University Munich",     logo: logo("LMU",  "14213D") },
      { name: "Heidelberg University",                   logo: logo("Heid", "14213D") },
      { name: "RWTH Aachen University",                  logo: logo("RWTH", "14213D") },
      { name: "Karlsruhe Institute of Technology",       logo: logo("KIT",  "14213D") },
      { name: "Humboldt University of Berlin",           logo: logo("HUB",  "14213D") },
      { name: "Free University of Berlin",               logo: logo("FUB",  "14213D") },
      { name: "Technical University of Berlin",          logo: logo("TUB",  "14213D") },
      { name: "University of Freiburg",                  logo: logo("Frei", "14213D") },
      { name: "University of Tübingen",                  logo: logo("Tüb",  "14213D") },
    ],
  },
];

export const COUNTRIES = RAW_COUNTRIES.map((c) => ({ ...c, facilities: FACILITIES }));
